export default __webpack_public_path__ + "static/media/365-BizTool-Dark-Logo.2bb2927f.png";